module.exports = __webpack_public_path__ + "static/media/price-analysis.5094477e.png";